var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductRequestIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11H18.52C18.083 10.9991 17.6577 11.1413 17.3091 11.405C16.9606 11.6686 16.708 12.0392 16.59 12.46L14.24 20.82C14.2249 20.8719 14.1933 20.9175 14.15 20.95C14.1067 20.9825 14.0541 21 14 21C13.9459 21 13.8933 20.9825 13.85 20.95C13.8067 20.9175 13.7751 20.8719 13.76 20.82L8.24 1.18C8.22485 1.12807 8.19327 1.08246 8.15 1.05C8.10672 1.01754 8.05409 1 8 1C7.94591 1 7.89327 1.01754 7.85 1.05C7.80673 1.08246 7.77515 1.12807 7.76 1.18L5.41 9.54C5.29246 9.95915 5.04138 10.3285 4.69486 10.592C4.34835 10.8555 3.92532 10.9988 3.49 11H1",
    stroke: "url(#paint0_linear_20_5406)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_5406",
    x1: 3.88762,
    y1: 2.70813,
    x2: 20.3879,
    y2: 22.1805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A95500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductRequestIcon);
export default __webpack_public_path__ + "static/media/product-request-icon.c37b5ca946b51bc90447e1991080be40.svg";
export { ForwardRef as ReactComponent };